(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["idea-centre"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('idea-centre-{{ section.id }}');
    if (!section) return;
    var layout = '{{ section.settings.layout }}';
    if (layout === 'image-right') {
      section.classList.add('image-right');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
